import React from 'react'

const badgeTypeList = {
  plain: 'bg-white border-lighter',
  // purple: 'text-purple-700 bg-purple-50',
  primary: 'bg-white text-info border-info fill-info',
  secondary: 'bg-white text-base-primary border-[#BE123C]',
  default: 'text-text-info bg-surface-brand-2 border-0',
  warning: 'bg-surface-warning-light text-text-warning',
  danger: 'text-red bg-base-secondary',
  // bluelight: 'text-bluelight-700 bg-bluelight-50',
  success: 'text-success bg-surface-success-light',
  base: 'text-brand-default bg-surface-brand-1 border-surface-brand-1',
  "warning-badge": 'text-surface-warning-dark border-surface-warning-dark',
  "danger-badge": 'text-button-danger border-button-danger',
  "success-badge": 'text-success border-success',
  // rose: 'text-rose-700 bg-rose-50'
}

function BadgeItem({ className = '', badgeType = 'primary', children, onClick }) {
  return (
    <div
      onClick={onClick}
      className={`text-xs rounded-full border border-solid flex gap-1 justify-center items-center max-w-fit text-center px-2 py-0.5 ${className} ${badgeTypeList[badgeType]}`}>
      {children}
    </div>
  )
}

export default BadgeItem
